"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMyFlashcardEntryInfo = exports.MyFlashcardEntryInfoSchema = exports.isMyFlashcardBackEntryInfo = exports.MyFlashcardBackEntryInfoSchema = exports.validateMyFlashcardEntries = exports.DEFAULT_MY_FLASHCARDS_ENTRIES_SIZE = exports.DEFAULT_MY_FLASHCARDS_RESULT_SIZE = exports.validateMyFlashcardWords = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../helpers/type_validation_helpers");
const custom_translation_types_1 = require("./custom_translation_types");
const flashcard_back_type_types_1 = require("./flashcard/flashcard_back_type_types");
const flashcard_type_types_1 = require("./flashcard/flashcard_type_types");
const bootcamp_sentence_types_1 = require("./sentence/bootcamp_sentence_types");
const sentence_word_types_1 = require("./sentence/sentence_word_types");
const dictionary_word_types_1 = require("./word/dictionary_word_types");
const word_entry_types_1 = require("./word/word_entry_types");
const word_types_1 = require("./word/word_types");
const MyFlashcardWordSchema = zod_1.z.object({
    ipa: zod_1.z.string().optional(),
    knownText: zod_1.z.string().array().optional(),
    learnText: zod_1.z.string(),
    reading: zod_1.z.string().optional(),
});
const MyFlashcardWordsSchema = MyFlashcardWordSchema.array();
const validateMyFlashcardWords = (data) => MyFlashcardWordsSchema.safeParse(data);
exports.validateMyFlashcardWords = validateMyFlashcardWords;
exports.DEFAULT_MY_FLASHCARDS_RESULT_SIZE = 200;
exports.DEFAULT_MY_FLASHCARDS_ENTRIES_SIZE = 20;
const MyFlashcardEntrySchema = zod_1.z.object({
    flashcardIds: zod_1.z.string().array(),
    gender: zod_1.z.string().optional(),
    id: zod_1.z.string(),
    ipa: zod_1.z.string().optional(),
    knownText: zod_1.z.string().optional(),
    learnText: zod_1.z.string(),
    reading: zod_1.z.string().optional(),
    sentenceAudioUrl: zod_1.z.string().optional(),
    sentenceKnownText: zod_1.z.string().optional(),
    sentenceLearnText: zod_1.z.string().optional(),
    wordAudioUrl: zod_1.z.string().optional(),
});
const MyFlashcardEntriesSchema = MyFlashcardEntrySchema.array();
const validateMyFlashcardEntries = (data) => MyFlashcardEntriesSchema.safeParse(data);
exports.validateMyFlashcardEntries = validateMyFlashcardEntries;
const FlashcardEntrySentenceWordSchema = sentence_word_types_1.SentenceWordSchema.extend({
    sentence_id: zod_1.z.string(),
    tags: zod_1.z.string().array(),
});
const FlashcardEntryWordSchema = word_types_1.WordSchema.extend({
    specialWord: zod_1.z
        .object({
        audioUrl: zod_1.z.string(),
        gender: zod_1.z.string().optional(),
        ipa: zod_1.z.string(),
        knownText: zod_1.z.string(),
        learnTextDiacritics: zod_1.z.string().optional(),
        reading: zod_1.z.string().optional(),
    })
        .optional(),
});
exports.MyFlashcardBackEntryInfoSchema = zod_1.z.object({
    customTranslation: custom_translation_types_1.CustomTranslationSchema.optional(),
    customTranslationId: zod_1.z.string().optional(),
    extendedWord: dictionary_word_types_1.ExtendedWordSchema.optional(),
    extendedWordId: zod_1.z.string().optional(),
    flashcardId: zod_1.z.string(),
    id: zod_1.z.string(),
    sentenceWord: FlashcardEntrySentenceWordSchema.optional(),
    sentenceWordId: zod_1.z.string().optional(),
    typeName: flashcard_back_type_types_1.AnyCreatableFlashcardBackTypeSchema,
    word: FlashcardEntryWordSchema.optional(),
    wordEntry: word_entry_types_1.WordEntryWithWordSchema.optional(),
    wordEntryId: zod_1.z.string().optional(),
    wordId: zod_1.z.string().optional(),
});
exports.isMyFlashcardBackEntryInfo = type_validation_helpers_1.getTypeValidationFunction(exports.MyFlashcardBackEntryInfoSchema);
exports.MyFlashcardEntryInfoSchema = zod_1.z.object({
    backs: exports.MyFlashcardBackEntryInfoSchema.array(),
    bootcampSentence: bootcamp_sentence_types_1.BasicBootcampSentenceSchema.optional(),
    bootcampSentenceId: zod_1.z.string().optional(),
    createdAt: zod_1.z.string(),
    customTranslation: custom_translation_types_1.CustomTranslationSchema.optional(),
    customTranslationId: zod_1.z.string().optional(),
    extendedWord: dictionary_word_types_1.ExtendedWordSchema.optional(),
    extendedWordId: zod_1.z.string().optional(),
    id: zod_1.z.string(),
    sentenceWord: FlashcardEntrySentenceWordSchema.optional(),
    sentenceWordId: zod_1.z.string().optional(),
    typeName: flashcard_type_types_1.AnyFlashcardTypeSchema,
    updatedAt: zod_1.z.string(),
    word: FlashcardEntryWordSchema.optional(),
    wordEntry: word_entry_types_1.WordEntryWithWordSchema.optional(),
    wordEntryId: zod_1.z.string().optional(),
    wordId: zod_1.z.string().optional(),
});
exports.isMyFlashcardEntryInfo = type_validation_helpers_1.getTypeValidationFunction(exports.MyFlashcardEntryInfoSchema);
//# sourceMappingURL=my_flashcard_words_types.js.map